module.exports = __webpack_public_path__ + "static/media/19.940f99dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/mouth/19.png
// module id = 800
// module chunks = 0